import Constants from 'api/constants.js'

export default {
   MESSAGE_URL:  Constants.BASE_URL + '/message',
   MESSAGES_URL: Constants.BASE_URL + '/messages'
}

export const Actions = {
   // write a single message
   write: 'message:write',

   // fetch single message
   read: 'message:read',

   // publish multiple messages
   // publish: 'messages:publish',

   // fetch a list of messages
   fetch: 'messages:fetch',

   // async consumption of a messages
   open:    'messages:stream:open',
   consume: 'messages:stream:consume',
   close:   'messages:stream:close',

   clear: 'messages:clear'
}



// WEBPACK FOOTER //
// lib/api/message/Constants.js